// CATEGORIES
export const GET_CATEGORIES = "GET_CATEGORIES";
export const GET_CATEGORIES_FAIL = "GET_CATEGORIES_FAIL";
export const GET_CATEGORIES_SUCCESS = "GET_CATEGORIES_SUCCESS";

// CATEGORIES NEW
export const CATEGORIES = "CATEGORIES";
export const CATEGORIES_FAIL = "CATEGORIES_FAIL";
export const CATEGORIES_SUCCESS = "CATEGORIES_SUCCESS";


//sub CATEGORIES NEW
export const GET_SUBCATEGORIES = "GET_SUBCATEGORIES";
export const GET_SUBCATEGORIES_FAIL = "GET_SUBCATEGORIES_FAIL";
export const GET_SUBCATEGORIES_SUCCESS = "GET_SUBCATEGORIES_SUCCESS";
